import { uiState } from '../state';
import { LEARN_MORE_LABEL } from '../textChat/buildLinksContent';
import { getInnerBorderRadiusProp, getNumPropVal } from './cssHelper';

export function generateCssForMarkdown(stylesheetMarker, classPrefix) {
    let keyFrames = '';
    const tableBorderColor = uiState.textChat.options?.bubbles?.response?.table?.borderColor || `#b7b5b5`;


    const responseBubbleFontSize = +(uiState.textChat.options?.bubbles?.response?.fontSize || 15);
    const responseBubbleBg = uiState.textChat.options?.bubbles?.response?.backgroundColor || `#ffffff`;
    const responseBubbleFontColor = uiState.textChat.options?.bubbles?.response?.color || `#171717`;
    const responseBubbleCodeBackgroundColor = uiState.textChat.options?.bubbles?.response?.codeBackgroundColor || `#f8f8f8`;
    const responseBubbleCodeBorderColor = uiState.textChat.options?.bubbles?.response?.codeBorderColor || `#DDD`;
    const linkColor = uiState.textChat.options?.bubbles?.response?.links?.color?.default || `#4183c4`;
    const linkHoverColor = uiState.textChat.options?.bubbles?.response?.links?.color?.hover || `#4183c4`;

    const learnMoreLinkBorderColor = uiState.textChat.options?.bubbles?.response?.learnMore?.links?.default?.borderColor || `#EAF2FC`;
    const learnMoreLinkHoverBorderColor = uiState.textChat.options?.bubbles?.response?.learnMore?.links?.hover?.borderColor || `#EAF2FC`;
    const learnMoreLinkActiveBorderColor = uiState.textChat.options?.bubbles?.response?.learnMore?.links?.active?.borderColor || `#EAF2FC`;


    const learnMoreLinkBackgroundColor = uiState.textChat.options?.bubbles?.response?.learnMore?.links?.default?.backgroundColor || `transparent`;
    const learnMoreLinkHoverBackgroundColor = uiState.textChat.options?.bubbles?.response?.learnMore?.links?.hover?.backgroundColor || `#EAF2FC`;
    const learnMoreLinkActiveBackgroundColor = uiState.textChat.options?.bubbles?.response?.learnMore?.links?.active?.backgroundColor || `#EAF2FC`;


    const learnMoreLinkNumberBackgroundColor = uiState.textChat.options?.bubbles?.response?.learnMore?.links?.default?.linkNumberBackgroundColor || `#EAF2FC`;
    const learnMoreLinkNumberHoverBackgroundColor = uiState.textChat.options?.bubbles?.response?.learnMore?.links?.hover?.linkNumberBackgroundColor || `#EAF2FC`;
    const learnMoreLinkNumberActiveBackgroundColor = uiState.textChat.options?.bubbles?.response?.learnMore?.links?.active?.linkNumberBackgroundColor || `#EAF2FC`;

    const learnMoreTopLeftBorderRadius = getNumPropVal(uiState.textChat.options?.bubbles?.response?.learnMore?.links?.borderRadius?.topLeft, 4);
    const learnMoreTopRightBorderRadius = getNumPropVal(uiState.textChat.options?.bubbles?.response?.learnMore?.links?.borderRadius?.topRight, 4);
    const learnMoreBottomRightBorderRadius = getNumPropVal(uiState.textChat.options?.bubbles?.response?.learnMore?.links?.borderRadius?.bottomRight, 4);
    const learnMoreBottomLeftBorderRadius = getNumPropVal(uiState.textChat.options?.bubbles?.response?.learnMore?.links?.borderRadius?.bottomLeft, 4);

    const cssRules = [
        `a {
        color: ${linkColor}!important;
        text-decoration: none!important;
    }`,
        `a:hover {
            color: ${linkHoverColor}!important;
            text-decoration: underline!important;
            cursor: pointer;
    }`,
        `a.disabled {
        color: ${responseBubbleFontColor}!important;
        pointer-events: none!important;
        cursor: text!important;
    }`,
        `a.alan-chat__link-disabled {
        color: ${responseBubbleFontColor}!important;
        pointer-events: none!important;
        cursor: text!important;
    }`,
        `p {
        color: inherit;
        margin: 0!important;
        font-size: ${responseBubbleFontSize}px!important;
    }`,
        `blockquote {
        margin: 0!important;
        font-size: ${responseBubbleFontSize}px!important;
    }`,
        `dl {
        margin: 0!important;
        font-size: ${responseBubbleFontSize}px!important;
    }`,
        `table {
        color: inherit;
        margin: 0!important;
        font-size: ${responseBubbleFontSize}px!important;
        word-break: initial!important;
        border-collapse: collapse;
    }`,
        `ul {
        padding-left: 30px!important; 
        margin: 0!important; 
        list-style-type: disc!important;
        font-size: ${responseBubbleFontSize}px!important;
    }`,
        `ul li {
       list-style-type: disc!important;
       font-size: ${responseBubbleFontSize}px!important;
    }`,
        `ol {
        padding-left: 40px!important;
        margin: 0!important; 
        list-style-type: decimal!important;
        font-size: ${responseBubbleFontSize}px!important;
    }`,
    `ol, ul {
        color: inherit;
        list-style-position: outside;
    }`,
        `ol li {
        list-style-type: decimal!important;
        font-size: ${responseBubbleFontSize}px!important;
    }`,
        `h1 { color: inherit; font-size: 2em!important;  line-height: 1.7!important; margin: 0 0 10px 0!important; font-weight: 600!important;  text-transform: none!important;}`,
        `h2 { color: inherit; font-size: 1.5em!important;  line-height: 1.7!important; margin: 0 0 10px 0!important; font-weight: 600!important;  text-transform: none!important;}`,
        `h3 { color: inherit; font-size: 1.25em!important;  line-height: 1.7!important; margin: 0 0 10px 0!important; font-weight: 600!important;  text-transform: none!important;}`,
        `h4 { color: inherit; font-size: 1em!important;  line-height: 1.7!important; margin: 0 0 10px 0!important; font-weight: 600!important;  text-transform: none!important;}`,
        `h5 { color: inherit; font-size: .875em!important;  line-height: 1.7!important; margin: 0 0 10px 0!important; font-weight: 600!important;  text-transform: none!important;}`,
        `h6 { color: inherit; font-size: .85em!important;  line-height: 1.7!important; margin: 0 0 10px 0!important; font-weight: 600!important;  text-transform: none!important;}`,
        `h1:after { display: none!important;}`,
        `h2:after { display: none!important;}`,
        `h3:after { display: none!important;}`,
        `h4:after { display: none!important;}`,
        `h5:after { display: none!important;}`,
        `h6:after { display: none!important;}`,
        `h1:before { display: none!important;}`,
        `h2:before { display: none!important;}`,
        `h3:before { display: none!important;}`,
        `h4:before { display: none!important;}`,
        `h5:before { display: none!important;}`,
        `h6:before { display: none!important;}`,
        `h1 + p {
        margin-top: 10px!important;
    }`,
        `h2 + p {
        margin-top: 10px!important;
    }`,
        `h3 + p {
        margin-top: 10px!important;
    }`,
        `h4 + p {
        margin-top: 10px!important;
    }`,
        `h5 + p {
        margin-top: 10px!important;
    }`,
        `h6 + p {
        margin-top: 10px!important;
    }`,
        `p + p {
        margin-top: 10px!important;
    }`,
        `* + pre {
        margin-top: 8px!important;
    }`,
        `* + ul {
        margin-top: 8px!important;
    }`,
        `ul + * {
        margin-top: 16px!important;
    }`,
        `* + ol {
        margin-top: 8px!important;
    }`,
        `ol + * {
        margin-top: 16px!important;
    }`,
        `* + blockquote {
        margin-top: 8px!important;
    }`,
        `blockquote + * {
        margin-top: 16px!important;
    }`,
        `audio {
        max-width: 100%!important;
        max-height: 100%!important;
    }`,
        `video {
        max-width: 100%!important;
        max-height: 100%!important;
    }`,
        `img {
        max-width: 100%!important;
        pointer-events: auto!important;
        cursor: pointer;
        max-height: 500px;
    }`,
        `code {
        background-color: ${responseBubbleCodeBackgroundColor}!important;
        border-radius: 3px!important;
        border: 1px solid ${responseBubbleCodeBorderColor}!important;
        font-family: Consolas, "Liberation Mono", Courier, monospace!important;
        margin: 0 2px!important;
        padding: 0 5px!important;
        white-space: pre-line!important;
        font-size: ${responseBubbleFontSize}px!important;
    }`,
        `code span {
        font-family: Consolas, "Liberation Mono", Courier, monospace!important;
        font-size: ${responseBubbleFontSize}px!important;
    }`,
        `pre {
        background-color: ${responseBubbleCodeBackgroundColor}!important;
        border-radius: 3px!important;
        border: 1px solid ${responseBubbleCodeBorderColor}!important;
        font-family: Consolas, "Liberation Mono", Courier, monospace!important;
        padding: 10px!important;
        white-space: pre-line!important;
        font-size: ${responseBubbleFontSize}px!important;
    }`,
        `pre code {
        background-color: ${responseBubbleCodeBackgroundColor}!important;
        border: none!important;
        margin: 0!important;
        padding: 0!important;
        white-space: pre-wrap!important;
        font-size: ${responseBubbleFontSize}px!important;
    }`,
        `hr {
        display: block!important;
        unicode-bidi: isolate!important;
        margin-block-start: 0.5em!important;
        margin-block-end: 0.5em!important;
        margin-inline-start: auto!important;
        margin-inline-end: auto!important;
        overflow: hidden!important;
        border-style: inset!important;
        border-width: 1px!important;
    }`,
        `blockquote {
        padding: 5px 20px 0!important;
        border-left: 5px solid #beb7b7!important;
        font-size: ${responseBubbleFontSize}px!important;
    }`,
        `table > tbody > tr > td {
        background-color: ${responseBubbleBg}!important;
        color: ${responseBubbleFontColor}!important;
    }`,
        `table > tbody > tr > th {
        color: ${responseBubbleFontColor}!important;
        background-color: ${responseBubbleBg}!important;
    }`,
        `table > thead > tr > th {
        font-weight: bold;
        text-align: center;
        padding: 4px 6px!important;
        border-top: 1px solid ${tableBorderColor}!important;
        border-right: 1px solid ${tableBorderColor}!important;
        border-left: 1px solid ${tableBorderColor}!important;
    }`,
        `table > tbody > tr > th {
        padding: 4px 6px!important;
        border-top: 1px solid ${tableBorderColor}!important;
        border-bottom: 1px solid ${tableBorderColor}!important;
        border-right: 1px solid ${tableBorderColor}!important;
        border-left: 1px solid ${tableBorderColor}!important;
    }`,
        `table > thead > tr > td {
        font-weight: bold;
        text-align: center;
        padding: 4px 6px!important;
        border-top: 1px solid ${tableBorderColor}!important;
        border-right: 1px solid ${tableBorderColor}!important;
        border-left: 1px solid ${tableBorderColor}!important;
        border-bottom: 1px solid ${tableBorderColor}!important;
    }`,
        `table > tbody > tr > td {
        padding: 4px 6px!important;
        border-top: 1px solid ${tableBorderColor}!important;
        border-right: 1px solid ${tableBorderColor}!important;
        border-left: 1px solid ${tableBorderColor}!important;
        border-bottom: 1px solid ${tableBorderColor}!important;
    }`,
        `strong {
        font-weight: bold!important;
    }`,
        `em {
        font-style: italic!important;
    }`,

        `sup.footnote-ref{
        background: ${learnMoreLinkNumberBackgroundColor};
        padding: 1px;
        border-radius: 4px;
        position: relative;
        top: -5px;
        font-size: ${responseBubbleFontSize}px!important;
    }`,
        `sup.footnote-ref:hover{
        background: ${learnMoreLinkNumberHoverBackgroundColor};
    }`,
        `sup.footnote-ref:active{
        background: ${learnMoreLinkNumberActiveBackgroundColor};
    }`,
        `.footnotes{
        padding-top: 10px;
        margin-top: 10px;
    }`,
        `.footnotes-list {
        counter-reset: list-counter;
        padding-left: 0!important;
    }`,
        `.footnotes-list:before {
        content: '${LEARN_MORE_LABEL}';
        font-weight: 600;
    }`,
        `.footnote-item {
        position: relative;
        display: inline-flex;
        align-items: center;
        max-width: 100%;
        border-radius: ${learnMoreTopLeftBorderRadius}px ${learnMoreTopRightBorderRadius}px ${learnMoreBottomRightBorderRadius}px ${learnMoreBottomLeftBorderRadius}px;
        cursor: pointer;
        border: 1px solid ${learnMoreLinkBorderColor};
        margin-bottom:4px;
        background-color: ${learnMoreLinkBackgroundColor};
    }`,
    `.footnote-item .footnote-backref {
        display: none;
    }`,
        `.footnote-item:hover {
        border: 1px solid ${learnMoreLinkHoverBorderColor};
        background-color: ${learnMoreLinkHoverBackgroundColor};
    }`,
        `.footnote-item:active {
        border: 1px solid ${learnMoreLinkActiveBorderColor};
        background-color: ${learnMoreLinkActiveBackgroundColor};
    }`,
        `.footnote-item p {
        margin-top: 0;
        margin-bottom: 0;
        padding-right: 6px;
        padding-left: 6px;
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: ${linkColor}!important;
    }`,
        `.footnote-item:hover p a {
        text-decoration: none!important;
        color: ${linkHoverColor}!important;
    }`,
        `.footnotes-list>.footnote-item::before {
        counter-increment: list-counter;
        content: counter(list-counter);
        padding: 4px 4px;
        background-color: ${learnMoreLinkNumberBackgroundColor};
        border-radius: ${getInnerBorderRadiusProp(learnMoreTopLeftBorderRadius)}px ${getInnerBorderRadiusProp(learnMoreTopRightBorderRadius)}px ${getInnerBorderRadiusProp(learnMoreBottomRightBorderRadius)}px ${getInnerBorderRadiusProp(learnMoreBottomLeftBorderRadius)}px;
        box-sizing: border-box;
        display: inline-block;
        min-width: 28px;
        text-align: center;
        color: ${linkColor}!important;
    }`,
        `.footnotes-list>.footnote-item:hover::before {
        color: ${linkHoverColor}!important;
        background-color: ${learnMoreLinkNumberHoverBackgroundColor};
    }`,
        `.footnotes-list>.footnote-item:active::before {
        color: ${linkHoverColor}!important;
        background-color: ${learnMoreLinkNumberActiveBackgroundColor};
    }`,
        `.footnotes-sep {
        display: none!important;
    }`,
        `.scroll-table {
        margin-bottom:10px;
        margin-top:10px;
    }`,
    `iframe {
        display:block;
    }`
    ];

    for (let i = 0; i < cssRules.length; i++) {
        const curRule = cssRules[i];
        keyFrames += stylesheetMarker + `${classPrefix} ${curRule}`;
    }

    return keyFrames;
}